import Size from "../data/Size";
import UIIcon, { IUIIconProps } from "./UIIcon";
import './UILoadingIcon.scss';

export interface IUILoadingIconProps extends IUIIconProps{

    fs?:string;
    colored?:boolean;
}


export default function UILoadingIcon($props:IUILoadingIconProps){

    let cn:string = "loadingIcon "+$props.className;
    if($props.colored){
        cn+=" colored";
    }
    cn = Size.addFontSize(cn,$props.fs,Size.s16);
    return (
        <UIIcon className={cn} flex={$props.flex} onClick={$props.onClick}  icon={UIIcon.LOADING}>
            {$props.children}
        </UIIcon>
    );
}


